export const environment = {
	production: false,
	showLogs: true,
	skipOnfido: false,
	api: 'https://api.soft-token-bel-dev.towerbank.com',
	wafUrl: 'https://783610e581f6.edge.sdk.awswaf.com/783610e581f6/8e72afdafbae/challenge.js'
};